import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'bp-activation-view-layout',
    templateUrl: './bp-activation-view-layout.component.html',
    styleUrls: ['./bp-activation-view-layout.component.scss'],
    standalone: true,
    imports: [MatIconModule, NgClass],
})
export class BpActivationViewLayoutComponent {
  @Input() title = 'Default title';
  @Input() description = 'Default description';
  @Input() bgColorClass = 'bg-black';
  @Input() hasFuseCompatibleIcon = true;
  @Input() iconClass = '';
  @Input() svgIcon = 'heroicons_outline:cube-transparent';
  @Input() rightFirstOnDesptop = true;
}
